
import { Form } from "antd"
import moment from "moment";
import { useEffect, useState } from "react"
import { URL_BACKEND } from "../../api/url"
import { elToast } from "../../functions/alertas";
import { formatearFecha } from "../../functions/formatearHora";


const useRegistroAspiranteIndividual = () => {

    var ct = new Date();
    var ciclo_actual = ct.getFullYear()

    var hoy = moment()
    hoy = moment(hoy, 'YYYY-MM-DD')


    // variables
    const [form] = Form.useForm()

    const [isLoading, setIsLoading] = useState( false )
    const [bachilleratos, setBachilleratos] = useState([])
    const [pk_bachillerato, setPk_bachillerato] = useState()
    const [pkCarrera, setPkCarrera] = useState()

    const [estatusPrematricula, setEstatusPrematricula] = useState("")
    const [textoHelpPrematricula, setTextoHelpPrematricula] = useState("")

    const [valoresForm, setValoresForm] = useState({
        ciclo_examen: ciclo_actual,
        sexo: 'Masculino',
        fecha_alta_universidad: hoy
    })


    const verificarExistenciaPrematricula = prematricula => {

        if ( prematricula.length === 0 ) {
            setEstatusPrematricula( "" )
            setTextoHelpPrematricula( "" )
            return
        }
        if ( prematricula.trim().length === 0 ) {
            return
        }

        const values = {
            prematricula,
            funcion: 'verificarExistenciaPrematricula'
        }

        setEstatusPrematricula( "validating" )
        setTextoHelpPrematricula( "Validando prematrícula" )

        fetch( URL_BACKEND, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
        })
        .then( res => res.json())
        .then( function(d) {


            if ( d.codigo === 1 ) {

                setEstatusPrematricula( "success" )
                setTextoHelpPrematricula( "Prematrícula disponible" )

            } else {

                setEstatusPrematricula( "error" )
                setTextoHelpPrematricula( "Prematrícula ocupada" )

            }

        })
        .catch( function(e) {
            console.log(e)

            setEstatusPrematricula( "" )
            setTextoHelpPrematricula( "" )

        })
    }



    // funciones
    const onFinish = ( values ) => {

        values.fecha_alta_universidad = formatearFecha( values.fecha_alta_universidad )

        values.funcion = 'registrarAspirante'
        values.fk_carrera = pkCarrera
        values.fk_bachillerato = pk_bachillerato

        console.log( values );

        fetch( URL_BACKEND, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
        })
        .then( res => res.json())
        .then( function(d) {

            setIsLoading(false)

            if ( d.codigo === 1 ) {
                elToast( d.mensaje )
            } else {
                elToast( d.mensaje, 'error' )
            }

        })
        .catch( function(e) {
            console.log(e)
            setIsLoading(false)
        })

    }

    const traerBachilleratos = () => {

        let datos = new FormData()
        datos.append('funcion', 'traerBachilleratos')

        fetch( URL_BACKEND, {
            method: 'post',
            body: datos
        })
        .then( res => res.json() )
        .then( function( d ){

            setBachilleratos( d )

        })

    }


    // useEffects
    useEffect(() => {
        traerBachilleratos()
    }, [])

    useEffect(() => {

        form.setFieldsValue( valoresForm )

    }, [])



    return {
        isLoading,
        onFinish,
        setPk_bachillerato,
        bachilleratos,
        setPkCarrera,
        valoresForm,
        form,
        verificarExistenciaPrematricula,
        estatusPrematricula,
        textoHelpPrematricula
    }
}

export default useRegistroAspiranteIndividual
